<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>

          <template v-slot:headerTitle>
            <div class="row align-items-center py-4 mx-0">

              <div class="col-auto">
                <span class="unselectable" style="font-size: 25px; color: black;">อนุมัติใบสั่งซื้อ (PO)</span>
              </div>

            </div>
          </template>

          <template v-slot:body>
            <div class="mx-3">
              <b-row style="align-items: flex-end;">

                <b-col cols="12" lg="3" class="pb-3">
                  <div class="iq-email-search d-flex">
                    <div style="width: 100%;">
                      <div class="form-group mb-0" style="height: 45px;">
                        <input v-model="search" @keydown="enterSearch" class="form-control" id="exampleInputEmail1" placeholder="Search"
                          style="width: 100%; height: 45px;">
                        <i style="color: #676767; top: 4px" class="search-link ri-search-line" />
                      </div>
                    </div>
                  </div>
                </b-col>

                <b-col cols="6" lg="2" class="pb-3">
                  <b-text style="color: black; white-space: nowrap">วันที่ใบสั่งซื้อ (เริ่มต้น)</b-text>
                  <div style="position: relative; margin-top: .4rem;" class="w-res-attendance time-picker-attendance">
                    <date-picker v-if="searchEndDate" placeholder="เลือกวันที่" id="datepicker-custom-1"
                      :config="optionsDatepickerStart" v-model="searchStartDate"></date-picker>
                    <date-picker v-else placeholder="เลือกวันที่" id="datepicker-custom-1"
                      :config="optionsDatepickerDefault" v-model="searchStartDate"></date-picker>
                    <i class="ri-calendar-line m-0 icon-calendar-edit" @click="onClickDatePicker(1)"
                      style="cursor: pointer;"></i>
                  </div>
                </b-col>

                <b-col cols="6" lg="2" class="pb-3">
                  <b-text style="color: black; white-space: nowrap">วันที่ใบสั่งซื้อ (สิ้นสุด)</b-text>
                  <div style="position: relative; margin-top: .4rem;" class="w-res-attendance time-picker-attendance">
                    <date-picker v-if="searchStartDate" placeholder="เลือกวันที่" id="datepicker-custom-2"
                      :config="optionsDatepickerEnd" v-model="searchEndDate"></date-picker>
                    <date-picker v-else placeholder="เลือกวันที่" id="datepicker-custom-2"
                      :config="optionsDatepickerDefault" v-model="searchEndDate"></date-picker>
                    <i class="ri-calendar-line m-0 icon-calendar-edit" @click="onClickDatePicker(2)"
                      style="cursor: pointer;"></i>
                  </div>
                </b-col>

                <b-col cols="12" lg="auto" class="pb-3">
                  <b-button @click="getPOApproveByClinic" type="button" variant="primary-custom"
                    class="w-100 btn-min-size" style="height: 45px;">
                    <i class="ri-search-line"></i>
                    ค้นหา
                  </b-button>
                </b-col>

                <b-col cols="auto" class="pb-3">
                  <div style="display: flex; align-items: center; height: 45px;">
                    <span class="mx-2 font-size-14 text-primary-custom">
                      {{ rows_po?.length > 0 ? (((currentPage - 1) * 10) + 1) + ' - ' + (((perPage *
                        currentPage) > rows_po?.length) ? rows_po?.length : (perPage * currentPage)
                      ) + ' of ' + rows_po_length : '0 of ' + rows_po_length }} รายการ
                    </span>
                  </div>
                </b-col>

              </b-row>
            </div>

            <b-col cols="12">
              <div class="table-responsive">
                <div class="table-wrapper-purchase-order-approve">
                  <b-table bordered hover :items="rows_po" :fields="columns_po" :current-page="currentPage"
                  :per-page="perPage" @pagination="onPagination" :tbody-tr-class="rowClass"
                  thead-class="table-header-color">

                  <template v-slot:cell(no)="data">
                    <span>{{ ((currentPage - 1) * 10) + data.index + 1 }}</span>
                  </template>

                  <template v-slot:cell(po_no)="data">
                    <a @click.prevent="getPOByIdforModalApprove(data.item.po_id)"
                      style="color: #0085FF; cursor: pointer;"><span>{{
                        data.item.po_no ||
                        '-' }}</span></a>
                  </template>

                  <template v-slot:cell(po_sup)="data">
                    <span>{{ data.item.po_sup_name || '-' }}</span>
                  </template>

                  <template v-slot:cell(po_date)="data">
                    <span>{{ formatDate(data.item.po_date) || '-' }}</span>
                  </template>

                  <template v-slot:cell(po_price)="data">
                    <span>{{ formatNumber(data.item.po_total_price) || '-' }}</span>
                  </template>

                  <template v-slot:cell(po_contact_name)="data">
                    <span>{{ data.item.po_sup_contact_name || '-' }}</span>
                  </template>

                  <template v-slot:cell(status)="data">
                    <b-button v-if="data.item.po_pos_id === 'f13f9448-c683-4149-aaaf-02bd7190f7cb'"
                      variant=" iq-bg-warning-custom btn-warning-border" style="min-width: 100px; cursor:default;">{{
                        data.item.pos_name }}</b-button>

                    <b-button v-else-if="data.item.po_pos_id === 'cb77c408-2823-4b5f-8f92-fb1c10af117b'"
                      variant=" iq-bg-success-custom btn-success-border" style="min-width: 100px; cursor:default;">{{
                        data.item.pos_name }}</b-button>

                    <b-button v-else-if="data.item.po_pos_id === 'c5de2506-fb4f-40d7-bc23-076e1d5e0b3c'"
                      variant=" iq-bg-info-custom btn-info-border" style="min-width: 100px; cursor:default;">{{
                        data.item.pos_name }}</b-button>

                    <b-button v-else-if="data.item.po_pos_id === '6ce3957c-3df2-46c4-9116-b8dcdb40a590'"
                      variant=" bg-danger-custom" style="min-width: 100px;"
                      @click.prevent="reasonModal = true, reasonTextShow = data.item.po_reason_not_approve">{{
                        data.item.pos_name }}</b-button>

                    <b-button v-else-if="data.item.po_pos_id === 'a5a10d90-ef99-4164-a9bc-d885e521d67c'"
                      variant=" iq-bg-info-custom btn-info-border" style="min-width: 100px; cursor:default;">{{
                        data.item.pos_name }}</b-button>

                    <span v-else>{{ '-' }}</span>
                  </template>

                  <template v-slot:cell(po_approve_name)="data">
                    <span>{{ data.item.po_approve_name || '-' }}</span>
                  </template>

                  <template v-slot:cell(management)="data">
                    <div style="display: flex;">
                      <b-button title="ดูรายงาน" variant=" iq-bg-report-custom btn-report-border mx-1" size="sm"
                        style="cursor: not-allowed;">
                        <i class="ri-article-line m-0"></i>
                      </b-button>

                      <b-button v-if="data.item.po_pos_id === 'f13f9448-c683-4149-aaaf-02bd7190f7cb'"
                        variant=" bg-success-custom mx-1" style="width: 100%;"
                        @click.prevent="POApprove(data.item.po_id)">อนุมัติ
                      </b-button>
                      <b-button v-else variant=" bg-dark-custom mx-1" style="width: 100%; cursor: not-allowed;">อนุมัติ
                      </b-button>

                      <b-button v-if="data.item.po_pos_id === 'f13f9448-c683-4149-aaaf-02bd7190f7cb'"
                        variant=" bg-danger-custom mx-1" style="width: 100%;"
                        @click.prevent="reasonModalAnswer = true, reasonTextSave = '', po_id_save = data.item.po_id">ไม่อนุมัติ
                      </b-button>
                      <b-button v-else variant=" bg-dark-custom mx-1" style="width: 100%; cursor: not-allowed;">ไม่อนุมัติ
                      </b-button>

                    </div>
                  </template>

                </b-table>
                </div>
              </div>
            </b-col>

            <b-pagination v-model="currentPage" :total-rows="rows_po?.length" :per-page="perPage" align="center" />

          </template>
        </iq-card>
      </b-col>
    </b-row>

    <!-- Reason Modal  -->
    <b-modal v-model="reasonModal" title="ไม่ผ่านการอนุมัติ" size='lg' centered @close.prevent="reasonModal = false"
      hide-footer>
      <div style="margin: 10px 30px;">
        <span style="word-break: break-word; color: black;">{{ reasonTextShow }}</span>
      </div>
    </b-modal>

    <!-- Reason Modal Answer  -->
    <b-modal v-model="reasonModalAnswer" title="เหตุผลที่ไม่อนุมัติ" size='lg' centered
      @close.prevent="reasonModalAnswer = false" no-close-on-backdrop>
      <template #modal-title>
        เหตุผลที่ไม่อนุมัติ <span style="color: red;">*</span>
      </template>

      <b-form-textarea type="text" v-model="reasonTextSave" placeholder="ข้อคิดเห็น"
        style="padding-right: 1rem; height: 100px; justify-items: flex-start;"></b-form-textarea>

      <template #modal-footer>
        <div class="w-100" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
          <b-button style="border-radius: 0.5rem; padding: 0 1.1rem !important;" variant="none"
            class="btn-min-size bg-save-custom" size="sm" @click.prevent="PONotApprove">
            <i class="save-data_ct" />บันทึก
          </b-button>

          <b-button variant="none" class="btn-min-size bg-danger-custom" style="border-radius: 0.5rem;" size="sm"
            @click.prevent="reasonModalAnswer = false">
            ยกเลิก
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Detail Quotation Modal  -->
    <b-modal v-model="detailPOModal" title="รายละเอียดใบสั่งซื้อ" size='xl' centered
      @close.prevent="detailPOModal = false" hide-footer>
      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">เลขที่ใบสั่งซื้อ : {{ PoDetail.po_no || '-' }}</b-text>
        </b-col>

        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">วันที่เลขใบสั่งซื้อ : {{ PoDetail.po_date || '-' }}</b-text>
        </b-col>
      </b-row>

      <hr style="width: calc(100% + 32px); height: 1px; color: #CCC; margin-left: -16px;" />

      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">อ้างอิงเลขใบสั่งซื้อ : {{ PoDetail.po_ref_po_no || '-' }}</b-text>
        </b-col>

        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">อ้างอิงเลขใบขอซื้อ : {{ PoDetail.po_ref_detail || '-' }}</b-text>
        </b-col>

        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">เลขที่อ้างอิง : {{ PoDetail.po_ref_no || '-' }}</b-text>
        </b-col>
      </b-row>

      <hr style="width: calc(100% + 32px); height: 1px; color: #CCC; margin-left: -16px;" />

      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">ชื่อซัพพลายเออร์ : {{ PoDetail.po_sup_name || '-' }}</b-text>
        </b-col>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">ชื่อผู้ติดต่อ : {{ PoDetail.po_sup_contact_name || '-' }}</b-text>
        </b-col>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">เบอร์โทรศัพท์ : {{ formatTel(PoDetail.po_sup_contact_tel || '') || '-' }}</b-text>
        </b-col>
      </b-row>

      <hr style="width: calc(100% + 32px); height: 1px; color: #CCC; margin-left: -16px;" />
      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">รายการสินค้า</b-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="table-responsive">
            <b-table bordered hover :items="poItemProduct" :fields="columns_poItemproduct" :tbody-tr-class="rowClass"
              thead-class="table-header-color" > <!-- :foot-clone="true" -->

              <template v-for="(column) in columns_poItemproduct" v-slot:[`cell(${column.key})`]="data">
                <template v-if="column.key === 'no'">
                  <span :key="column.key">{{ data.index + 1 }}</span>
                </template>

                <template v-if="column.key === 'code_proser'">
                  <span :key="column.key">{{ data.item.no || data.item.pri_item_data.no || '-' }}</span>
                </template>

                <template v-if="column.key === 'name_proser'">
                  <span :key="column.key">{{ data.item.name || data.item.pri_item_data.name || '-' }}</span>
                </template>

                <template v-if="column.key === 'quantity'">
                  <span :key="column.key">{{ formatNumber(data.item.quantity) }}</span>
                </template>

                <template v-if="column.key === 'lp'">
                  <span :key="column.key">{{ formatNumber(data.item.lp) }}</span>
                </template>

                <template v-if="column.key === 'discount'">
                  <span :key="column.key">{{ formatNumber(data.item.discount) }}</span>
                </template>

                <template v-if="column.key === 'total_price'">
                  <span :key="column.key">{{ formatNumber(data.item.row_price) }}</span>
                </template>
              </template>

              <!-- <template #foot()="data">
                <span></span>
              </template>

              <template #foot(discount)="data">
                <span>{{ 'สรุปรวมราคา' }}</span>
              </template>

              <template #foot(total_price)="data">
                <span>{{ formatNumber(poAllItemSumProduct) }}</span>
              </template> -->

            </b-table>
            <!-- <div :style="'display: flex; justify-content: flex-end;'" class="mt-2">
              <b-col style="text-align: end;" lg="2" md="2" sm="6">
                <label><b>{{ 'Vat 7%' }}</b></label>
              </b-col>
              <b-col style="text-align: center;" lg="2" md="2" sm="6">
                <label><b style="margin-left: 3rem;">{{ formatNumber(poAllItemSumVatProduct) }}</b></label>
              </b-col>
            </div>
            <div :style="'display: flex; justify-content: flex-end;'" class="">
              <b-col style="text-align: end;" lg="2" md="2" sm="6">
                <label><b>{{ 'สรุปรวมราคา' }}</b></label>
              </b-col>
              <b-col style="text-align: center;" lg="2" md="2" sm="6">
                <label><b style="margin-left: 3rem;">{{ formatNumber(poAllItemSumProduct) }}</b></label>
              </b-col>
            </div> -->
          </div>
        </b-col>
      </b-row>

      <hr style="width: calc(100% + 32px); height: 1px; color: #CCC; margin-left: -16px;" />
      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">รายการวัตถุดิบ</b-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="table-responsive">
            <b-table bordered hover :items="poItemMaterial" :fields="columns_poItemrawmat" :tbody-tr-class="rowClass"
              thead-class="table-header-color" > <!-- :foot-clone="true" -->

              <template v-for="column in columns_poItemrawmat" v-slot:[`cell(${column.key})`]="data">
                <template v-if="column.key === 'no'">
                  <span :key="column.key">{{ data.index + 1 }}</span>
                </template>

                <template v-if="column.key === 'type_proser'">
                  <span :key="column.key">{{ data.item.mg_name || data.item.pri_item_data.mg_name || '-' }}</span>
                </template>

                <template v-if="column.key === 'brand'">
                  <span :key="column.key">{{ data.item.mb_name || data.item.pri_item_data.mb_name || '-' }}</span>
                </template>

                <template v-if="column.key === 'type'">
                  <span :key="column.key">{{ data.item.mt_name || data.item.pri_item_data.mt_name || '-' }}</span>
                </template>

                <template v-if="column.key === 'unit'">
                  <span :key="column.key">{{ data.item.unit_name || data.item.pri_item_data.unit_name || '-' }}</span>
                </template>

                <template v-if="column.key === 'quantity'">
                  <span :key="column.key">{{ formatNumber(data.item.quantity) }}</span>
                </template>

                <template v-if="column.key === 'lp'">
                  <span :key="column.key">{{ formatNumber(data.item.lp) }}</span>
                </template>

                <template v-if="column.key === 'discount'">
                  <span :key="column.key">{{ formatNumber(data.item.discount) }}</span>
                </template>

                <template v-if="column.key === 'total_price'">
                  <span :key="column.key">{{ formatNumber(data.item.row_price) }}</span>
                </template>
              </template>

              <!-- <template #foot()="data">
                <span></span>
              </template>

              <template #foot(discount)="data">
                <span>{{ 'สรุปรวมราคา' }}</span>
              </template>

              <template #foot(total_price)="data">
                <span>{{ formatNumber(poAllItemSumMaterial) }}</span>
              </template> -->

            </b-table>
          </div>
        </b-col>
      </b-row>

      <div :style="'display: flex; justify-content: flex-end;'" class="mt-2">
        <b-col style="text-align: end;" lg="2" md="2" sm="6">
          <label><b>{{ 'ราคารวมสินค้า' }}</b></label>
        </b-col>
        <b-col style="text-align: center;" lg="2" md="2" sm="6">
          <label><b style="margin-left: 3rem;">{{ formatNumber(poAllItemSumProduct) }}</b></label>
        </b-col>
      </div>
      <div :style="'display: flex; justify-content: flex-end;'" class="mt-2">
        <b-col style="text-align: end;" lg="2" md="2" sm="6">
          <label><b>{{ 'ราคารวมวัตถุดิบ' }}</b></label>
        </b-col>
        <b-col style="text-align: center;" lg="2" md="2" sm="6">
          <label><b style="margin-left: 3rem;">{{ formatNumber(poAllItemSumMaterial) }}</b></label>
        </b-col>
      </div>
      <div :style="'display: flex; justify-content: flex-end;'" class="mt-2">
        <b-col style="text-align: end;" lg="2" md="2" sm="6">
          <label><b>{{ 'ส่วนลดท้ายบิล' }}</b></label>
        </b-col>
        <b-col style="text-align: center;" lg="2" md="2" sm="6">
          <label><b style="margin-left: 3rem;">{{ formatNumber(poDiscountFinal) }}</b></label>
        </b-col>
      </div>
      <div :style="'display: flex; justify-content: flex-end;'" class="mt-2">
        <b-col style="text-align: end;" lg="2" md="2" sm="6">
          <label><b>{{ 'Vat 7%' }}</b></label>
        </b-col>
        <b-col style="text-align: center;" lg="2" md="2" sm="6">
          <label><b style="margin-left: 3rem;">{{ formatNumber(poAllItemSumVat) }}</b></label>
        </b-col>
      </div>
      <div :style="'display: flex; justify-content: flex-end;'" class="">
        <b-col style="text-align: end;" lg="2" md="2" sm="6">
          <label><b>{{ 'สรุปรวมราคา' }}</b></label>
        </b-col>
        <b-col style="text-align: center;" lg="2" md="2" sm="6">
          <label><b style="margin-left: 3rem;">{{ formatNumber(poAllItemSum) }}</b></label>
        </b-col>
      </div>
    </b-modal>

  </b-container>
</template>

<style>
.table-wrapper-purchase-order-approve {
  overflow-x: auto;
  width: 100%;
}

.table-wrapper-purchase-order-approve .sticky-col-right-td {
  position: sticky;
  right: 0;
  background: white;
  z-index: 5;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  outline: 1px solid #dee2e6;
  box-sizing: border-box;
}

.table-wrapper-purchase-order-approve .sticky-col-right-th {
  position: sticky;
  right: 0;
  background: #024187;
  z-index: 5;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  outline: 1px solid #dee2e6;
  box-sizing: border-box;
}
</style>

<script>
import { xray } from '../../config/pluginInit'
// import router from '@/router'
import Vue from 'vue'
import Axios from 'axios'
import moment from 'moment'
import { configAPI } from '../../configBase'

const iconDate = {
  time: 'fas fa-clock',
  date: 'fas fa-calendar',
  up: 'fas fa-chevron-up',
  down: 'fas fa-chevron-down',
  previous: 'fas fa-chevron-left',
  next: 'fas fa-chevron-right',
  today: 'fas fa-calendar-day',
  clear: 'fas fa-trash-alt',
  close: 'fas fa-times'
}

export default {
  name: 'PurchaseOrderApprove',

  components: {
  },

  data () {
    return {
      clnId: null,
      userId: null,
      search: '',
      searchStartDate: null,
      searchEndDate: null,
      columns_po: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        { label: 'เลขที่ใบสั่งซื้อ', key: 'po_no', class: 'text-center table-size-200-400' },
        { label: 'ซัพพลายเออร์', key: 'po_sup', class: 'text-center table-size-200-400' },
        { label: 'วันที่ใบสั่งซื้อ', key: 'po_date', class: 'text-center table-size-200-400' },
        { label: 'ราคา', key: 'po_price', class: 'text-center table-size-200-400' },
        { label: 'ชื่อผู้ติดต่อ', key: 'po_contact_name', class: 'text-center table-size-200-400' },
        { label: 'สถานะ', key: 'status', class: 'text-center table-size-200-400' },
        { label: 'ชื่อผู้อนุมัติ', key: 'po_approve_name', class: 'text-center table-size-200-400' },
        { label: 'Management', key: 'management', class: 'text-center table-size-300-500', tdClass: 'sticky-col-right-td', thClass: 'sticky-col-right-th' }
      ],
      rows_po: [],
      rows_po_length: 0,
      currentPage: 1,
      perPage: 10,
      reasonModal: false,
      reasonModalAnswer: false,
      reasonTextShow: '',
      reasonTextSave: '',
      po_id_save: null,
      optionsDatepickerDefault: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        useStrict: false,
        minDate: false,
        maxDate: false,
        icons: iconDate
      },
      optionsDatepickerStart: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        useStrict: false,
        minDate: false,
        maxDate: false,
        icons: iconDate
      },
      optionsDatepickerEnd: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        useStrict: false,
        minDate: false,
        maxDate: false,
        icons: iconDate
      },
      detailPOModal: false,
      poAllItemSumProduct: 0,
      poAllItemSumVatProduct: 0,
      poAllItemSumMaterial: 0,
      poAllItemSumVatMaterial: 0,
      poAllItemSumVat: 0,
      poAllItemSum: 0,
      poDiscountFinal: 0,
      PoDetail: {},
      poItemProduct: [],
      poItemMaterial: [],
      columns_poItemproduct: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        { label: 'รหัสสินค้า', key: 'code_proser', class: 'text-center table-size-200-400 ellips' },
        { label: 'ชื่อสินค้า', key: 'name_proser', class: 'text-center table-size-200-400 ellips' },
        { label: 'จำนวน', key: 'quantity', class: 'text-center table-size-200-400' },
        { label: 'ราคา', key: 'lp', class: 'text-center table-size-200-400' },
        { label: 'ส่วนลด', key: 'discount', class: 'text-center table-size-200-400' },
        { label: 'ราคารวม', key: 'total_price', class: 'text-center table-size-200-400' }
      ],
      columns_poItemrawmat: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        { label: 'หมวดหมู่', key: 'type_proser', class: 'text-center table-size-200-400' },
        { label: 'แบรนด์', key: 'brand', class: 'text-center table-size-200-400 ellips' },
        { label: 'ประเภท', key: 'type', class: 'text-center table-size-200-400' },
        { label: 'หน่วยนับ', key: 'unit', class: 'text-center table-size-200-400' },
        { label: 'จำนวน', key: 'quantity', class: 'text-center table-size-200-400' },
        { label: 'ราคา', key: 'lp', class: 'text-center table-size-200-400' },
        { label: 'ส่วนลด', key: 'discount', class: 'text-center table-size-200-400' },
        { label: 'ราคารวม', key: 'total_price', class: 'text-center table-size-200-400' }
      ]
    }
  },

  computed: {
  },

  watch: {
    'searchStartDate': function (newDate) {
      this.optionsDatepickerEnd.minDate = newDate
    },
    'searchEndDate': function (newDate) {
      this.optionsDatepickerStart.maxDate = newDate
    }
  },

  async mounted () {
    this.clnId = JSON.parse(sessionStorage.getItem('user')).cln_id || null
    this.userId = JSON.parse(sessionStorage.getItem('user')).usr_id || null

    await this.getPOApproveByClinic()

    xray.index()
  },

  methods: {
    async enterSearch (e) {
      if (e.key === 'Enter') {
        await this.getPOApproveByClinic()
      }
    },
    formatDate (date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return '-'
      }
    },

    formatNumber (number) {
      if (number) {
        return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    },

    formatTel (tel) {
      if (tel) {
        let formatTel = tel.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        return formatTel
      } else {
        return ''
      }
    },

    SwalError (error, message) {
      Vue.swal.fire({
        title: `<span class="" style="font-size: 25px; color: black; text-align: center">${message}</span>`,
        html: '<span>' + error + '</span>',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
        confirmButtonColor: '#089bab',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1'
        }
      })
    },

    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.no % 2 === 1) return 'table-body-color'
    },

    onClickDatePicker (number) {
      let datePicker = null
      datePicker = document.getElementById(`datepicker-custom-${number}`)
      datePicker.focus()
    },

    onPagination (page) {
      this.currentPage = page
    },

    async getPOApproveByClinic () {
      const searchData = {
        search: this.search.trim() || null,
        searchStartDate: this.searchStartDate
          ? moment(this.searchStartDate, 'DD/MM/YYYY').startOf('day')
          : null,
        searchEndDate: this.searchEndDate
          ? moment(this.searchEndDate, 'DD/MM/YYYY').endOf('day')
          : null
      }

      await Axios.request({
        method: 'post',
        url: `${configAPI.SALE_PORT}/api/purchaseOrder/clinic/${this.clnId}/getPOApproveByClinic`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: searchData
      }).then((response) => {
        this.rows_po = response.data.data
        this.rows_po_length = response.data.dataCount
      }).catch((error) => {
        this.SwalError(error.message, 'เกิดข้อผิดพลาดในดึงข้อมูล')
      })
    },

    async POApprove (poId) {
      const temp = {
        user_id: this.userId
      }

      Vue.swal.fire({
        title: '<span class="" style="font-size: 23px; color: black; text-align: center">คุณมั่นใจว่าจะอนุมัติใบสั่งซื้อนี้ใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#0DC268',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#E03C3C',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          await Axios.request({
            method: 'POST',
            url: `${configAPI.SALE_PORT}/api/purchaseOrder/clinic/${this.clnId}/approvePO/${poId}`,
            headers: {
              'Content-Type': 'application/json'
            },
            data: temp
          }).then((response) => {
            Vue.swal.fire({
              title: '<span class="" style="font-size: 25px; color: black; text-align: center">อนุมัติสำเร็จ</span>',
              icon: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              timer: 1500
            }).then(async () => {
              window.location.reload()
            })
          }).catch((err) => {
            this.SwalError(err.message, 'ลบข้อมูลไม่สำเร็จ')
          })
        }
      })
    },

    async PONotApprove () {
      if (this.reasonTextSave === '' || this.reasonTextSave === null) {
        this.SwalError('', 'กรุณากรอกเหตุผลที่ไม่อนุมัติ')
      } else {
        const temp = {
          user_id: this.userId,
          reasonTextSave: this.reasonTextSave
        }

        Vue.swal.fire({
          title: '<span class="" style="font-size: 22px; color: black; text-align: center">คุณมั่นใจว่าจะไม่อนุมัติใบสั่งซื้อนี้ใช่หรือไม่?</span>',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
          confirmButtonColor: '#0DC268',
          cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
          cancelButtonColor: '#E03C3C',
          customClass: {
            confirmButton: 'custom-confirm-button-class mx-1',
            cancelButton: 'custom-confirm-button-class mx-1'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            await Axios.request({
              method: 'POST',
              url: `${configAPI.SALE_PORT}/api/purchaseOrder/clinic/${this.clnId}/notApprovePO/${this.po_id_save}`,
              headers: {
                'Content-Type': 'application/json'
              },
              data: temp
            }).then((response) => {
              Vue.swal.fire({
                title: '<span class="" style="font-size: 25px; color: black; text-align: center">ไม่อนุมัติสำเร็จ</span>',
                icon: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                timer: 1500
              }).then(async () => {
                window.location.reload()
              })
            }).catch((err) => {
              this.SwalError(err.message, 'ลบข้อมูลไม่สำเร็จ')
            })
          }
        })
      }
    },

    async getPOByIdforModalApprove (poId) {
      await Axios.request({
        method: 'GET',
        url: `${configAPI.SALE_PORT}/api/purchaseOrder/clinic/${this.clnId}/getPOByIdforModalApprove/${poId}`,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        // console.log(res.data.data[0])
        let tempData = res.data.data[0]
        this.PoDetail = {
          po_no: tempData?.po_no || null,
          po_date: tempData?.po_date ? moment(tempData?.po_date).format('DD/MM/YYYY') : '',
          po_sup_name: tempData?.po_sup_data?.name || null,
          po_sup_contact_name: tempData?.po_sup_data?.constact_name || null,
          po_sup_contact_tel: tempData?.po_sup_data?.contact_tel || null,
          po_ref_po_no: tempData?.po_ref_po_no || null,
          po_ref_no: tempData?.po_ref_no || null, // quotation
          po_ref_detail: tempData?.po_ref_detail || null // pr
        }
        let arrList = {
          prdList: [],
          rmList: []
        }
        let sumproductprice = 0
        let summaterialprice = 0
        for (let item of tempData?.po_item_list) {
          item.quantity = item.poi_amount
          item.lp = item.poi_price
          item.discount = item.poi_discount
          item.row_price = item.poi_amount * item.poi_price
          item.poi_id = poId ? null : item.poi_id
          if (item.poi_prd_id) {
            item.id = item.poi_prd_id
            sumproductprice += parseFloat(item.poi_item_data.row_price !== undefined ? item.poi_item_data.row_price : item.poi_amount * item.poi_price)
            arrList.prdList.push({ ...item, ...item.poi_item_data })
          } else if (item.poi_mat_id) {
            item.id = item.poi_mat_id
            summaterialprice += parseFloat(item.poi_item_data.row_price !== undefined ? item.poi_item_data.row_price : item.poi_amount * item.poi_price)
            arrList.rmList.push({ ...item, ...item.poi_item_data })
          }
        }
        this.poItemProduct = arrList.prdList || 0
        this.poAllItemSumProduct = (sumproductprice || 0).toFixed(2)
        this.poItemMaterial = arrList.rmList || 0
        this.poAllItemSumMaterial = (summaterialprice || 0).toFixed(2)
        this.poDiscountFinal = (tempData.po_final_discount || 0).toFixed(2)
        if (tempData.po_incl_vat) {
          this.poAllItemSumVat = (Number(tempData.po_total_price) - (sumproductprice + summaterialprice)).toFixed(2)
        }
        this.poAllItemSum = Number(tempData.po_total_price).toFixed(2)
        this.detailPOModal = true
      }).catch((err) => {
        this.SwalError(err, 'Error')
      })
    }
  }
}
</script>
